import React, { Component } from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import { FaRegEdit } from 'react-icons/fa'
import { AiOutlineSave } from 'react-icons/ai'

import { Button } from '../../../buttons'

export default class Searchbar extends Component {
  render() {
    const editAttachment = get(this.props, 'editAttachment')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const canEdit = get(projectByID, '$can_edit')
    const clickEdit = get(this.props, 'clickEdit')
    const confirmEditAttachment = get(this.props, 'confirmEditAttachment')
    const cancelEdit = get(this.props, 'cancelEdit')
    const clickAddAttachment = get(this.props, 'clickAddAttachment')

    return (
      <Root>
        { !isPresale &&
        <ButtonGroup>
          { !editAttachment && canEdit &&
          <Button
            theme='#28a745'
            icon={ <FaRegEdit style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ () => clickEdit() }
          >
            Edit
          </Button>
          }
          { editAttachment &&
          <Button
            theme='#28a745'
            icon={ <AiOutlineSave style={ { fontSize: 16 } } /> }
            width='70px'
            height='26px'
            onClick={ () => confirmEditAttachment() }
          >
            Save
          </Button>
          }
          { editAttachment &&
          <Button
            theme='#6c757d'
            width='70px'
            height='26px'
            onClick={ () => cancelEdit() }
            style={ { marginLeft: 12 } }
          >
            Cancel
          </Button>
          }
          { editAttachment &&
          <Button
            theme='#28a745'
            width='120px'
            height='26px'
            onClick={ () => clickAddAttachment() }
            style={ { marginLeft: 12 } }
          >
            + Upload Files
          </Button>
          }
        </ButtonGroup>
        }
      </Root>
    )
  }
}
const Root = styled.div`
  height: 40px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: #ffffff;
  padding: 10px 16px;
`

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`



// WEBPACK FOOTER //
// ./src/components/project-information/searchbar/searchbar-attachment/index.js